import { createI18n } from 'vue-i18n'
import Cookies from 'js-cookie'
import { CookiesToken } from '@/types/CookiesToken'
import { getBrowserLanguage, getCookieValue } from '.'
import gamerules from './rules'

const messages = {
    'zh-cn': {
        serverselection: {
            lineSelection: '线路选择',
            p1: '线路为绿色',
            p2: '可直接点击进入，红色',
            p3: '代表该线路不可用，',
            p4: '如三个线路均不可用，请联系在线客服获取更多线路，并输入所获取的线路地址点击进入，即可游戏，祝您游戏愉快。',
            line1: '线路一',
            line2: '线路二',
            line3: '线路三',
            customline: '自定义线路',
            enter: '进入',
            lineerror: 'ip 地址错误'
        },
        login: {
            username: '请输入您的用户名',
            password: '输入您的密码',
            commandmode: '指令',
            phonemode: '电投',
            enterphonenumber: '请输入电话号码',
            verificationcode: '请输入验证码',
            useragreement: '同意用户协议',
            login: '登 入',
            guestlogin: '游客登入',
            usernameerror: '请输入用户名',
            passworderror: '请输入密码',
            phoneerror: '电话号码为必填项',
            codeerror: '无效验证码',
            demologin: {
                title: '验证码',
                codeerror: '请先输入验证码'
            }
        },
        common: {
            onlineservice: '在线客服',
            networkerror: '网络错误',
            confirm: '确定',
            cancel: '取消',
            pager: '每页{0}条, 共 {1} 条',
            goto: '前往',
            baccarat: '百家乐',
            dragontiger: '龙虎',
            hint: '提示',
            on: '开',
            off: '关',
            more: '更多',
            return: '返回',
            music: '音乐开关',
            sound: '声音开关',
            close: '关闭',
            amount: '数量'
        },
        dialogs: {
            useragreement: {
                title: '用户协议',
                content:
                    '尊敬的贵宾，欢迎光临好彩娯楽，您即将使用好彩娯楽指令投注，公司将以您发送的指令为准，开牌后一切输赢归您所有，网站路子仅供参考，一切以现场游戏结果为准。若您同意，请点击下方确 定按钮，若您有异议，请您关闭网页，联系账房，谢谢！'
            },
            reservetabletext: '确定要包桌吗？',
            tip: '小费',
            amount: '金额',
            gameplay: {
                title: '玩法选择',
                classic: '经典玩法',
                special: '特殊玩法',
                switchplaymode: '切换玩法',
                hint: '游戏中，也可以通过点击切换玩法按钮来选择'
            }
        },
        roadmap: {
            banker: '庄',
            player: '闲',
            tie: '和',
            tiger: '虎',
            dragon: '龙',
            pair: '对',
            ask: '{0}问路'
        },
        loby: {
            baccarattable: '百家乐',
            dragontigertable: '龙虎',
            universal: '通用台',
            phonemode: '电投台',
            commandmode: '指令台',
            atthistable: '您在此桌',
            all: '全部',
            baccarat: ' 百家乐',
            dragontiger: ' 龙虎',
            multiple: '多台',
            tip: '小费',
            menu: '功能',
            startmultibetting: ' 开始多台投注',
            selectupto: '选择最多4张台进行投注',
            fourtablesonly: '抱歉，您只能选择 4 个表',
            alllimit: '全部限红',
            allgames: '全部游戏',
            fastbaccarat: '极速百家乐',
            firstdealbaccarat: '先发牌百家乐',
            traditionalbaccarat: '传统百家乐',
            traditionaldragontiger: '传统龙虎',
            firstdealdragontiger: '先发牌龙虎',
            fastdragontiger: '极速龙虎',
            promotions: '优惠活动',
            viewdetails: '查看详情',
            fast: '极速',
            classic: '经典'
        },
        prompts: {
            networkerror: '当前网络不佳，请重新尝试',
            bindtogunner: '您未绑定枪手，请先绑定枪手再进入台桌',
            iscommandtableselectother: '号台桌为指令台,请选择其他台桌游戏！',
            isphonetableselectother: '号台桌为电投台,请选择其他台桌游戏！',
            tableisreserved: '该台桌已被包桌，请选择其他台桌进行投注',
            sessionexpired: '您因不活动而被注销',
            betting: {
                gunnerbetmode: '当前由枪手下注，请切换模式',
                nobetallowed: '当前不能下注',
                openisconfirmednomorebets: '已确认开牌，无法再投注',
                betsuccess: '下注成功'
            },
            nobettimeoutidle: '您长时间没有投注 , 请重新登录',
            switchtoselfbettingmode: '您已切换至自主投注模式',
            switchgunerbettingmode: '已切换至枪手投注模式',
            pausegamerequestsetnt:
                '您已发送暂停指令，接线员已收到您的指令信息！',
            tablecloseforaccess: '当前台桌已关闭访问，请选择其他台桌进行投注',
            socketnetworkerror: '网络错误，请您稍后重新登录系统，谢谢！',
            insufficientbalance: '余额不足',
            d7error: '35局以后不可下注龙7',
            b8error: '35局以后不可下注熊8',
            bigtigererror: '35局以后不可下注大老虎',
            smalltigererror: '35局以后不可下注小老虎',
            super6tigermutual: '大小老虎和Super6不可同时下注'
        },
        setting: {
            customerservice: '在线客服',
            gamerules: '游戏规则',
            gamesetting: '游戏设置',
            changepassword: '修改密码',
            chipssetting: '筹码设置',
            betrecord: '投注记录',
            exitgame: '登出游戏'
        },
        changepassword: {
            oldpassword: '旧密码',
            newpassword: '新密码',
            confirmpassword: '确认密码',
            enteroldpassword: '请输入旧密码',
            enternewpassword: '请输入新密码',
            passwordnotmatch: '密码不匹配',
            success: '修改成功',
            changepasswordhint:
                '为了您的账号安全，建议您初次登录时重设密码，密码不得少于6位，且需字母和数字的组合.'
        },
        gamesetting: {
            video: '视频开关',
            sound: '声音开关'
        },
        bethistory: {
            totalbet: '总投注',
            totalvalidbets: '总有效投注',
            totalwinorloss: '总输赢',
            table: '桌号',
            gameid: '游戏编号',
            gametype: '游戏类型',
            bettype: '投注类型',
            gameresult: '游戏结果',
            card: '牌型',
            winorloss: '输赢',
            date: '日期'
        },
        game: {
            settling: '结算中',
            shoeround: '靴局',
            one: '单',
            total: '总',
            changeshoe: '换靴',
            freegame: '飞牌',
            tip: '小费',
            pause: '暂停',
            opencard: '开牌',
            menu: '功能',
            switchtable: '切换桌台',
            baccarat: '百家乐',
            commissionfreebaccarat: '免水百家乐',
            limit: '限红',
            g2limit: '庄闲 限红:',
            g1limit: '龙虎 限红:',
            tielimit: '和 限红:',
            pairlimit: '对子 限红:',
            super6limit: 'SUPER 6',
            dragon7limit: '龙7',
            bear8limit: '熊8',
            bigtigerlimit: '大老虎',
            smalltigerlimit: '小老虎',
            customchip: '自定义',
            playerpair: '闲对',
            tie: '和',
            bankerpair: '庄对',
            player: '闲',
            banker: '庄',
            dragon: '龙',
            tiger: '虎',
            confirmbet: '确认投注',
            cancelbet: '取消投注',
            gameid: '游戏ID',
            close: '关闭',
            shuffling: '洗牌中',
            betting: {
                banker: '庄',
                player: '闲',
                bankerpair: '庄对',
                playerpair: '闲对',
                tiger: '虎',
                dragon: '龙',
                tie: '和',
                repeatbet: '重复投注',
                cancelbet: '取消投注',
                confirmbet: '确定投注'
            }
        },
        rules: {
            baccarat: gamerules['zh-cn'].baccarat,
            dragontiger: gamerules['zh-cn'].dragontiger
        },
        multibetting: {
            redlimit: '限红',
            remove: '移除',
            enter: '进入',
            shoe: '靴',
            juno: '局'
        },
        'ingame': '停止',
        'bet': '下注',
        bettype: {
            bear8: '熊8',
            smalltiger: '小老虎',
            bigtiger: '大老虎',
            dragon7: '龙7',
            super6: 'SUPER 6'
        }
    },
    'zh-hk': {
        serverselection: {
            lineSelection: '線路選擇',
            p1: '線路為綠色',
            p2: '可直接點選進入，紅色',
            p3: '代表該線路不可用，',
            p4: '如三條線路皆不可用，請聯絡線上客服取得更多線路，並輸入所取得的線路位址點選進入，即可遊戲，祝您遊戲愉快。 ',
            line1: '線路一',
            line2: '線路二',
            line3: '線路三',
            customline: '自訂線路',
            enter: '進入',
            lineerror: 'ip 位址錯誤'
        },
        login: {
            username: '請輸入您的使用者名稱',
            password: '輸入您的密碼',
            commandmode: '指令',
            phonemode: '電投',
            enterphonenumber: '請輸入電話號碼',
            verificationcode: '請輸入驗證碼',
            useragreement: '同意使用者協議',
            login: '登 入',
            guestlogin: '遊客登入',
            usernameerror: '請輸入使用者名稱',
            passworderror: '請輸入密碼',
            phoneerror: '電話號碼為必填',
            codeerror: '無效驗證碼',
            demologin: {
                title: '驗證碼',
                codeerror: '請先輸入驗證碼'
            }
        },
        common: {
            onlineservice: '線上客服',
            networkerror: '網路錯誤',
            confirm: '確定',
            cancel: '取消',
            pager: '每頁{0}條, 共 {1} 條',
            goto: '前往',
            baccarat: '百家樂',
            dragontiger: '龍虎',
            hint: '提示',
            on: '開',
            off: '關',
            more: '更多',
            return: '返回',
            music: '音樂開關',
            sound: '聲音開關',
            close: '關閉',
            amount: '數量'
        },
        dialogs: {
            useragreement: {
                title: '使用者協議',
                content:
                    '尊敬的貴賓，歡迎光臨好彩娛樂，您即將使用好彩娛樂指令投注，公司將以您發送的 指令為準，開牌後一切輸贏歸您所有，網站路子僅提供參考，一切以現場遊戲結果為準。若您同意，請點擊下方確定按鈕，若您有異議，請您關閉網頁，聯繫帳房，謝謝 !'
            },
            reservetabletext: '確定要包桌嗎？',
            tip: '小費',
            amount: '金額',
            gameplay: {
                title: '玩法選擇',
                classic: '經典玩法',
                special: '特殊玩法',
                switchplaymode: '切換玩法',
                hint: '遊戲中，也可以通過點擊切換玩法按鈕來選擇'
            }
        },
        roadmap: {
            banker: '莊',
            player: '閒',
            tie: '和',
            tiger: '虎',
            dragon: '龍',
            pair: '對',
            ask: '{0}問路'
        },
        loby: {
            baccarattable: '百家樂',
            dragontigertable: '龍虎',
            universal: '通用檯',
            phonemode: '電投檯',
            commandmode: '指令檯',
            atthistable: '您在此桌',
            all: '全部',
            baccarat: ' 百家樂',
            dragontiger: ' 龍虎',
            multiple: '多檯',
            tip: '小費',
            menu: '功能',
            startmultibetting: ' 開始多檯投注',
            selectupto: '選擇最多4張檯進行投注',
            fourtablesonly: '抱歉，您只能選擇 4 個表格',
            alllimit: '全部限紅',
            allgames: '全部遊戲',
            fastbaccarat: '極速百家樂',
            firstdealbaccarat: '先發牌百家樂',
            traditionalbaccarat: '傳統百家樂',
            traditionaldragontiger: '傳統龍虎',
            firstdealdragontiger: '先發牌龍虎',
            fastdragontiger: '極速龍虎',
            promotions: '優惠活動',
            viewdetails: '查看詳情',
            fast: '極速',
            classic: '經典'
        },
        prompts: {
            networkerror: '目前網路不佳，請重新嘗試',
            bindtogunner: '您未綁定槍手，請先綁定槍手再進入台桌',
            iscommandtableselectother: '號台桌為指令台,請選擇其他台桌遊戲！ ',
            isphonetableselectother: '號台桌為電投台,請選擇其他台桌遊戲！ ',
            tableisreserved: '該台桌已被包桌，請選擇其他台桌進行投注',
            sessionexpired: '您因不活動而被註銷',
            betting: {
                gunnerbetmode: '目前由槍手下注，請切換模式',
                nobetallowed: '目前不能下注',
                openisconfirmednomorebets: '已確認開牌，無法再投注',
                betsuccess: '下注成功'
            },
            nobettimeoutidle: '您長時間沒有投注 , 請重新登入',
            switchtoselfbettingmode: '您已切換至自主投注模式',
            switchgunerbettingmode: '已切換至槍手投注模式',
            pausegamerequestsetnt:
                '您已發送暫停指令，接線員已收到您的指示訊息！',
            tablecloseforaccess: '當前台桌已關閉訪問，請選擇其他台桌進行投注',
            socketnetworkerror: '網路錯誤，請您稍後重新登入系統，謝謝！',
            insufficientbalance: '餘額不足',
            d7error: '35局以後不可下注龍7',
            b8error: '35局以後不可下注熊8',
            bigtigererror: '35局以後不可下注大老虎',
            smalltigererror: '35局以後不可下注小老虎',
            super6tigermutual: '大小老虎和Super6不可同時下注'
        },
        setting: {
            customerservice: '線上客服',
            gamerules: '遊戲規則',
            gamesetting: '遊戲設定',
            changepassword: '修改密碼',
            chipssetting: '籌碼設定',
            betrecord: '投注記錄',
            exitgame: '登出遊戲'
        },
        changepassword: {
            oldpassword: '舊密碼',
            newpassword: '新密碼',
            confirmpassword: '確認密碼',
            enteroldpassword: '請輸入舊密碼',
            enternewpassword: '請輸入新密碼',
            passwordnotmatch: '密碼不符',
            success: '修改成功',
            changepasswordhint:
                '為了您的帳號安全，建議您初次登入時重設密碼，密碼不得少於6位，且需字母和數字的組合.'
        },
        gamesetting: {
            video: '視訊開關',
            sound: '聲音開關'
        },
        bethistory: {
            totalbet: '總投注',
            totalvalidbets: '總有效投注',
            totalwinorloss: '總輸贏',
            table: '桌號',
            gameid: '遊戲編號',
            gametype: '遊戲類型',
            bettype: '投注類型',
            gameresult: '遊戲結果',
            card: '牌型',
            winorloss: '輸贏',
            date: '日期'
        },
        game: {
            settling: '結算中',
            shoeround: '靴局',
            one: '單',
            total: '總',
            changeshoe: '換靴',
            freegame: '飛牌',
            tip: '小費',
            pause: '暫停',
            opencard: '開牌',
            menu: '功能',
            switchtable: '切換桌檯',
            baccarat: '百家樂',
            commissionfreebaccarat: '免水百家樂',
            limit: '限紅',
            g2limit: '莊閒 限紅:',
            g1limit: '龍虎 限紅:',
            tielimit: '和 限紅:',
            pairlimit: '對子 限紅:',
            super6limit: 'SUPER 6',
            dragon7limit: '龍7',
            bear8limit: '熊8',
            bigtigerlimit: '大老虎',
            smalltigerlimit: '小老虎',
            customchip: '自訂',
            playerpair: '閒對',
            tie: '和',
            bankerpair: '莊對',
            player: '閒',
            banker: '莊',
            dragon: '龍',
            tiger: '虎',
            confirmbet: '確認投注',
            cancelbet: '取消投注',
            gameid: '遊戲ID',
            close: '關閉',
            shuffling: '洗牌中',
            betting: {
                banker: '莊',
                player: '閒',
                bankerpair: '莊對',
                playerpair: '閒對',
                tiger: '虎',
                dragon: '龍',
                tie: '和',
                repeatbet: '重複投注',
                cancelbet: '取消投注',
                confirmbet: '確定投注'
            }
        },
        rules: {
            baccarat: gamerules['zh-hk'].baccarat,
            dragontiger: gamerules['zh-hk'].dragontiger
        },
        multibetting: {
            redlimit: '限紅',
            remove: '移除',
            enter: '進入',
            shoe: '靴',
            juno: '局'
        },
        ingame: {
            bet: '下注',
            cancel: '取消'
        },
        bettype: {
            bear8: '熊8',
            smalltiger: '小老虎',
            bigtiger: '大老虎',
            dragon7: '龙7',
            super6: 'SUPER 6'
        }
    }
}

const i18n = createI18n({
    legacy: false,
    locale: getCookieValue(CookiesToken.LANG) || getBrowserLanguage(),
    fallbackLocale: 'zh-cn',
    globalInjection: true,
    warnHtmlInMessage: false,
    warnHtmlMessage: false,
    messages
})

export default i18n
